import * as React from "react";
import { ChevronRight, Phone } from "lucide-react";
import { Button } from "@/components/ui/button";
import { AspectRatio } from "@/components/ui/aspect-ratio";
const maintenanceItems = ["Cybersecurity & Threat Protection", "AI & Intelligent Automation", "Web & Mobile App Development", "Managed IT & Cloud Solutions"];
export default function OurTechEcosystem() {
  return <section data-section-id="261559" id="our-tech-ecosystem" className="py-16 md:py-24 bg-background text-foreground">
      <div className="page-container">
        <div className="grid grid-cols-1 md:grid-cols-2 gap-12 items-center">
          {}
          <div className="order-2 md:order-1">
            <h2 className="text-3xl md:text-5xl font-bold font-default text-foreground mb-4 tracking-tight">
              Our Tech Ecosystem
            </h2>
            <div className="w-12 h-1 bg-primary mb-8 rounded-md"></div>
            <ul className="space-y-6 mb-8">
              {maintenanceItems.map((item, i) => <li key={i} data-index={i} className="flex items-center gap-4 group cursor-pointer">
                  <div className="flex-shrink-0 w-8 h-8 rounded-md bg-muted border border-border flex items-center justify-center text-primary group-hover:bg-primary group-hover:text-primary-foreground transition-all duration-300 shadow-sm">
                    <ChevronRight className="w-5 h-5" />
                  </div>
                  <span className="text-xl font-default font-medium text-muted-foreground group-hover:text-foreground transition-colors duration-300">{item}</span>
                </li>)}
            </ul>
            <Button size="lg" className="gap-2 bg-primary text-primary-foreground hover:bg-primary/90 rounded-md font-default font-semibold shadow-lg shadow-primary/20 transition-all duration-300" asChild>
              <a href="/ConnectPage">
                <Phone className="w-5 h-5" />
                Consult our experts
              </a>
            </Button>
          </div>

          {}
          <div className="order-1 md:order-2">
            <AspectRatio ratio={4 / 5}>
              <img src="https://wpvc-images.s3.us-east-1.amazonaws.com/images/1687829/img/apex_it_solutions_3d_render.png" data-wvc-srcset="https://wpvc-images.s3.us-east-1.amazonaws.com/images/1687829/img/apex_it_solutions_3d_render.png-wvc-srcset" data-wvc-sizes="https://wpvc-images.s3.us-east-1.amazonaws.com/images/1687829/img/apex_it_solutions_3d_render.png-wvc-sizes" alt="Futuristic IT Solutions Render" className="rounded-md object-cover w-full h-full shadow-2xl border border-white/10 backdrop-blur-sm" loading="lazy" />
            </AspectRatio>
          </div>
        </div>
      </div>
    </section>;
}